import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fechaActual } from "../../store/action";

export default function LabModal({ isOpen, onClose, onConfirm, especimen, que }) {
    const { t } = useTranslation("global");
    
    // Helper to get today in YYYY-MM-DD
    const getToday = () => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const [formData, setFormData] = useState({
        fechaRecepcion: getToday(),
        investigador: "",
        lugarLaboratorio: "",
        cantidadBolsas: "",
        cantidadBochones: que === 'bochon' ? "1" : "",
        preparadorAsignado: especimen?.preparador !== "Sin datos" ? especimen?.preparador : "",
        fechaFinalizacion: "",
        observaciones: ""
    });

    useEffect(() => {
        if (especimen && isOpen) {
            setFormData(prev => ({
                ...prev,
                preparadorAsignado: especimen.preparador !== "Sin datos" ? especimen.preparador : prev.preparadorAsignado,
                cantidadBochones: que === 'bochon' ? "1" : prev.cantidadBochones
            }));
        }
    }, [especimen, que, isOpen]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleAccept = () => {
        onConfirm(formData);
    };

    return (
        <Modal show={isOpen} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton style={{ background: 'linear-gradient(120deg, #2f5a4a 0%, #4a8169 100%)', color: 'white' }}>
                <Modal.Title>{t("LAB_MODAL_TITLE")}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: '#f4f8f6' }}>
                <Form>
                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_RECEPCION")}</Form.Label>
                            <Form.Control 
                                type="date" 
                                name="fechaRecepcion" 
                                value={formData.fechaRecepcion} 
                                onChange={handleChange} 
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_INVESTIGADOR")}</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="investigador" 
                                value={formData.investigador} 
                                onChange={handleChange} 
                                placeholder="Investigador responsable..."
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_LUGAR")}</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="lugarLaboratorio" 
                                value={formData.lugarLaboratorio} 
                                onChange={handleChange} 
                                placeholder="Lugar en laboratorio..."
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_BOLSAS")}</Form.Label>
                            <Form.Control 
                                type="number" 
                                name="cantidadBolsas" 
                                value={formData.cantidadBolsas} 
                                onChange={handleChange} 
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_BOCHONES")}</Form.Label>
                            <Form.Control 
                                type="number" 
                                name="cantidadBochones" 
                                value={formData.cantidadBochones} 
                                onChange={handleChange} 
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>{t("PREPARADOR")}</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="preparadorAsignado" 
                                value={formData.preparadorAsignado} 
                                onChange={handleChange} 
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>{t("LAB_FINALIZACION")}</Form.Label>
                            <Form.Control 
                                type="date" 
                                name="fechaFinalizacion" 
                                value={formData.fechaFinalizacion} 
                                onChange={handleChange} 
                            />
                        </Form.Group>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>{t("LAB_OBS")}</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3} 
                            name="observaciones" 
                            value={formData.observaciones} 
                            onChange={handleChange} 
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: '#f4f8f6' }}>
                <Button variant="secondary" onClick={onClose}>
                    {t("CANCEL")}
                </Button>
                <Button variant="success" onClick={handleAccept} style={{ backgroundColor: '#355f4f', borderColor: '#2f5a4a' }}>
                    {t("ACCEPT")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
